import DOMPurify from 'dompurify';
import React from 'react';
import styled from 'styled-components';

interface AppStoreModalProps {
  releaseNote: string | null;
}

/**
 * @param {AppStoreModalProps} { selectedPartner }
 * @return {*}
 */
function AppStoreModal({ releaseNote }: AppStoreModalProps) {
  const sanitizer = DOMPurify.sanitize;

  return (
    <StyledAppStoreModal data-component-name="AppStoreModal">
      {releaseNote ? (
        <div
          dangerouslySetInnerHTML={{
            __html: sanitizer(releaseNote || ''),
          }}
        ></div>
      ) : (
        <div></div>
      )}
    </StyledAppStoreModal>
  );
}

const StyledAppStoreModal = styled.section<{}>`
  padding: 20px;
`;

export default React.memo(AppStoreModal);
